import { ListKeyManager, ListKeyManagerOption } from '@angular/cdk/a11y';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Office } from '@emi/shared/models';
import { AuthState, selectUserInfo } from '@emi/shared/state/auth';
import { getHelpResourcesState, HelpResourcesState, fetchContactUsOffices } from '@emi/shared/state/help-resources';
import { select, Store } from '@ngrx/store';

@Component({
    selector: 'via-our-offices',
    templateUrl: './our-offices.component.html',
    styleUrls: ['./our-offices.component.scss'],
})
export class OurOfficesComponent implements OnInit {
    @ViewChildren('listItem')
    public listItems: QueryList<ListKeyManagerOption>;

    public userCountry: any;
    public offices: Array<Office>;
    public selectedOffice?: Office;
    public keyManager: ListKeyManager<any>;

    constructor(private store: Store<AuthState>, private helpResourcesStore: Store<HelpResourcesState>) {}

    public ngOnInit(): void {
        this.helpResourcesStore.dispatch(fetchContactUsOffices());
        this.helpResourcesStore.select(getHelpResourcesState).subscribe((state) => {
            this.offices = state.offices;
            this.setDefaultOffice(this.userCountry);
        });
        this.store.pipe(select(selectUserInfo)).subscribe((user) => (this.userCountry = user.userData.country));
    }

    public selectOffice(selectedOffice: Office): void {
        this.selectedOffice = selectedOffice;
    }

    public setDefaultOffice(country: string): void {
        if (this.offices.length === 0) return;

        this.selectedOffice = this.offices.find((office: Office) => office.location === country);

        if (!this.selectedOffice) {
            this.selectedOffice = this.offices.find((office: Office) => office.location === 'London');
        }
    }

    public ngAfterViewInit(): void {
        this.keyManager = new ListKeyManager(this.listItems).withWrap();
    }

    public setFocus(): void {
        if (this.keyManager.activeItemIndex === -1) {
            this.keyManager.setFirstItemActive();
        }
    }

    public keyEvents(event: KeyboardEvent, office: Office): void {
        switch (event.key) {
            case 'ArrowDown':
            case 'ArrowUp': {
                this.keyManager.onKeydown(event);
                this.keyManager.activeItem.nativeElement.focus();
                return;
            }
            case ' ':
            case 'Enter': {
                this.selectOffice(office);
            }
        }
    }
}
